module.exports = __webpack_public_path__ + "media/images/home/ic_meet-4285d414fdd96c3b4be7402411f81cf9.svg";